import { accessMangerBasePath, convertKey, docAcqBasePath, docSearchBasePath, docVerificationBasePath, refDataBasepath } from "../constants/env-url";
import { DOC_SEARCH_ONLY_USER_ROLES, DOC_VERIFICATION_ONLY_USER_ROLES, PAYG_USER_ROLES, publicDomainUrl } from "./config";
import { encryptMyPassword, ROLES} from "../constants/commonConstants"
import { PRIVACY_POLICY_URL } from "./constant";

const checkIsRoleAvailable = (eligibleRoles: string[], userRoles: string[]) => eligibleRoles.some(element => userRoles.includes(element));

export const isDocSearchOnlyUser = (userRoles: string[]) => {
  return checkIsRoleAvailable(DOC_SEARCH_ONLY_USER_ROLES, userRoles);
}

export const isDocVerificationOnlyUser = (userRoles: string[]) => {
  return checkIsRoleAvailable(DOC_VERIFICATION_ONLY_USER_ROLES, userRoles);
}

export const redirectToRespectiveAppByRoles = (userRoles: string[]) => {
  if (isDocSearchOnlyUser(userRoles)) {
    window.location.href = `${docSearchBasePath}`;
  }
  if (isDocVerificationOnlyUser(userRoles)) {
    window.location.href = `${docVerificationBasePath}`;
  }
}

export const isPayGUserRoleSelected = (roles: string[]) => roles.some(element => PAYG_USER_ROLES.includes(element));

export const isBasicOrProUser = (roles: string[]) => roles.some(element => [ROLES.BASIC_ACCESS_SUBSCRIBER, ROLES.PRO_ACCESS_SUBSCRIBER].includes(element));

export const isDataBrowserUser = (roles: string[]) => {
  return roles.some(element => [ROLES.DATA_BROWSER_USER].includes(element));
}

const base64ToArrayBuffer = (base64: string): ArrayBuffer => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};

const deriveAesKey = async (salt: Uint8Array, keySize = 128, iterations = 1000) => {
  const encoder = new TextEncoder();
  const baseKey = await crypto.subtle.importKey(
    "raw",
    encoder.encode(convertKey),
    { name: "PBKDF2" },
    false,
    ["deriveKey"]
  );

  return crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt,
      iterations,
      hash: "SHA-256"
    },
    baseKey,
    { name: "AES-CBC", length: keySize },
    true,
    ["encrypt", "decrypt"]
  );
};

export const decryptData = async (encryptedText: string): Promise<any> => {
  const decoder = new TextDecoder();
  const decoded = atob(encryptedText);
  const [ivBase64, saltBase64, cipherBase64] = decoded.split("::");
  const iv = new Uint8Array(base64ToArrayBuffer(ivBase64));
  const salt = new Uint8Array(base64ToArrayBuffer(saltBase64));
  const encrypted = base64ToArrayBuffer(cipherBase64);
  const key = await deriveAesKey(salt);
  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    key,
    encrypted
  );
  return decoder.decode(decrypted);
};

export const decryptUserData = () => {
  const encryptedUser = localStorage.getItem('u-info');
  if (encryptedUser) {
    return decryptData(encryptedUser).then((decryptedText) => {
      return JSON.parse(decryptedText);
    });
  }
};

export const isPayGAdmin = (roles: string) => {
  return "PAYG Team Admin".includes(roles);
}

export const handleSaveUserInfo = async (user: any) => {
  const encrypted_userInfo = await encryptMyPassword(JSON.stringify(user));
  localStorage.setItem('u-info', encrypted_userInfo);
};

export const setCookie = (cname: string, cvalue: string) => {
  document.cookie = cname + "=" + cvalue + ";path=/;domain=.infraclear.com";
}

const redirectTo = (link: any) => {
  window.open(link, "_self");
}

export const navigateToRespectiveApp = (module: any) => {
  switch (module.key) {
    case "REF_DATA":
      // code block
      redirectTo(`${refDataBasepath}`)
      break;
    case "DOC_VERIFICATION":
      redirectTo(`${docVerificationBasePath}`)
      break;
    case "ACCESS_MANAGER":
      redirectTo(`${accessMangerBasePath}`)
      break;
    case "DOC_SEARCH":
      redirectTo(`${docSearchBasePath}`)
      break;
    case "DOC_ACQUISITION":
      redirectTo(`${docAcqBasePath}`)
      break;
  }
}

export const getOrdinal = (num: number) => {
  const v = num % 100;
  
  if (v >= 11 && v <= 13) {
    return num + "th";
  }
  
  switch (num % 10) {
    case 1: return num + "st";
    case 2: return num + "nd";
    case 3: return num + "rd";
    default: return num + "th";
  }
}

export const getPrivacyPolicyUrl = (type: string) => {
  switch (type) {
    case PRIVACY_POLICY_URL.TERMS_OF_USE:
      return `${publicDomainUrl}/terms-of-use`;
    case PRIVACY_POLICY_URL.PRIVACY_POLICY:
      return `${publicDomainUrl}/privacy-policy`;
    case PRIVACY_POLICY_URL.SALES_AGREEMENT:
      return `${publicDomainUrl}/sales-agreement`;
    default:
      return ""
  }
}

export const getPrivacyPolicyTitle = (type: string) => {
  switch (type) {
    case PRIVACY_POLICY_URL.TERMS_OF_USE:
      return "Terms of Use";
    case PRIVACY_POLICY_URL.PRIVACY_POLICY:
      return "Privacy Policy";
    case PRIVACY_POLICY_URL.SALES_AGREEMENT:
      return "Sales Agreement";
    default:
      return ""
  }
}